import { EducationLevel } from '@borg/types';

class EducationLevelsRepository extends Repository<EducationLevel> {
  getMany() {
    return this._getMany({ url: '/apps/education-levels' });
  }
}

export const educationLevelsRepository = new EducationLevelsRepository();
